
import { Link, Outlet } from 'react-router-dom';
import auth from '../../firebase.init';
import { useAuthState } from 'react-firebase-hooks/auth';
import  useAdmin from '../../hooks/useAdmin'
import Loding from '../Shared/Loding';
const DashBoard = () => {
  const [user] = useAuthState(auth);
 
  const [admin,adminLoading]=useAdmin(user) 
  if(adminLoading){
    return <Loding></Loding>
  }
   return (
   

<div className="drawer lg:drawer-open">
  <input id="my-drawer-2" type="checkbox" className="drawer-toggle" />
  <div className="drawer-content  ">
 
  
    <h2 className='text-2xl font-bold text-purple-500 mb-5 mt-5 text-center' >Welcome Back {user.displayName}</h2>
                    
                      <Outlet></Outlet>
  </div> 
  <div className="drawer-side z-[999] lg:z-[0] ">
    <label htmlFor="my-drawer-2" aria-label="close sidebar" className="drawer-overlay"></label> 
    <ul className="menu p-2 w-48  bg-base-200 min-h-full text-base-content">
    {
           admin? '' : <>
           
         <li><Link to="/dashboard/addRiview">Add a review </Link></li>
         <li><Link to="/dashboard/order">My Order </Link></li>
        </>
        }
           
         <li><Link to='/dashboard'>My Profile</Link></li>
      
          

        {admin && <>
           <li><Link to="/dashboard/alluser">Make Admin</Link></li>
           <li><Link to="/dashboard/mangepart">Mange Part</Link></li>
           
           <li><Link to="/dashboard/mangeorder">Mange Order</Link></li>
         <li><Link to="/dashboard/addpart">Add part</Link></li>
           
           
            </>} 
    </ul>
  
  </div>
</div>

    );
};

export default DashBoard;